<template>
    <div class="container container--utilisateur-list">

        <ImpersonateUserForm v-if="$can('INCARNER_UTILISATEURS') && canShowImpersonate && isCurrentUserRepresentant"></ImpersonateUserForm>

        <Loader v-if="!isReady"></Loader>

        <List v-else
            :filtering="this"
            :itemNameSingular="'utilisateur'"
            :itemNamePlural="'utilisateurs'" >

            <template v-slot:actions>

                <Button 
                    class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>

                <router-link
                    class="woocommerce-button button"
                    :to="{ name: 'utilisateurNew' }"
                    v-if="$can('CREER_MODIFIER_UTILISATEURS') && $setting('USER_CREATE_ENABLED')">Nouvel utilisateur</router-link>                    


            </template>

            <template v-slot:filters>


                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher par nom, code, ou adresse e-mail"/>
                </ListFilter>

            </template>

            <template v-slot:heading>                
                <div class="cell cell--main criteria">
                    <Sorter criteria="name">Nom</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="code">code</Sorter>
                </div>
                <div class="cell cell--main criteria">
                    <Sorter criteria="email">Adresse e-mail</Sorter>
                </div>
                <div class="cell">
                    Profil
                </div>
                <div class="cell criteria">
                    <Sorter criteria="validiteFin">Actif jusqu'au</Sorter>
                </div>  
                <div class="cell">
                    État
                </div>
                <div v-if="$can('CREER_MODIFIER_UTILISATEURS') && $setting('USER_UPDATE_ENABLED')" class="cell cell--actions">
                    Actions
                </div>                       
            </template>

            <ul class="list__content utilisateur-list" v-if="hasContent">

                <li class="list__content__item"
                    v-for="utilisateur in items"
                    :key="utilisateur.id">

                    <ListItem class="list-item--card"
                        :item="utilisateur"
                        :route="route">
                        <Cell type="main">{{ utilisateur.name }}</Cell>
                        <Cell type="secondary">{{ utilisateur.code }}</Cell>
                        <Cell type="main">{{ utilisateur.email }}</Cell>
                        <Cell type="secondary">{{ utilisateur.profil.nom }}</Cell>
                        <Cell type="date secondary"><Date :date="utilisateur.validiteFin" /></Cell>
                        <Cell type="state">
                            <Badge type="success" v-if="utilisateur.isCreated && utilisateur.isActif">Actif</Badge>
                            <Badge type="secondary" v-if="utilisateur.isCreated && !utilisateur.isActif">Désactivé</Badge>
                            <Badge type="warning" v-if="!utilisateur.isCreated">En cours de création</Badge>
                        </Cell>
                        <Cell type="actions">
                            <button class="woocommerce-button button"
                            
                                @click.prevent="edit(utilisateur)"
                                v-if="$can('CREER_MODIFIER_UTILISATEURS') && $setting('USER_UPDATE_ENABLED')">
                                <span class="fa fa-edit"></span>
                            </button>
                        </Cell>                        
                    </ListItem>

                </li>

            </ul>

            <div class="container_list container_list--no-result" v-else>
                <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucun utilisateur</h1>
            </div>

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les utilisateurs suivants</button>
            </div>            
            
        </List>

    </div>
</template>

<script>
import Badge from '@/components/badge/Badge.vue'
import Button from '@/components/button/Button.vue'
import Date from '@/components/date/Date.vue'
import List, { Cell, ListFilter, ListItem, Sorter }  from '@/components/list/List.vue'
import Loader from '@/components/loader/Loader.vue'
import ImpersonateUserForm from '@/components/utilisateur/ImpersonateUserForm.vue'

import api from '@/api/proxyWeb/utilisateurs'
import Router, { routes } from '@/router'
import { isNotImpersonated } from '@/helpers/auth'

import filtering from "@/containers/filtering";

export default {

    name: 'UtilisateurList',

    data: function() {
        return {
            filters: {
                query: ''
            },
            route: routes.UTILISATEUR,
            processingXlsx: false
        }
    },

    computed: {
        canShowImpersonate() {
            return isNotImpersonated()
        },
        representantProfilId() {
            return this.$store.state.settings.current.PROFIL_CONSTANTS?.REPRESENTANT || 5
        },
        isCurrentUserRepresentant() {
            // Récupère le profil ID depuis le store
            const currentUser = this.$store.state.utilisateurs.current
            const currentUserProfilId = currentUser?.profil?.id
            return currentUserProfilId === this.representantProfilId
        }
    },

    methods: {

        downloadXlsx() {
            this.processingXlsx = true
            api.getXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        }, 

        edit: function(utilisateur) {
            Router.push({
                name: routes.UTILISATEUR_EDIT,
                params: { id: utilisateur.id } 
            });
        }      
    },
  
    created () {
        this.useFilter(api)
    },

    components: {
        Badge,
        Button,
        Cell,
        Date,
        List,
        ListFilter,
        ListItem,
        Loader,
        Sorter,
        ImpersonateUserForm
    },

    mixins: [ filtering ]
}
</script>

<style scoped>

.table {
    width: 100%;
}

.table__action {
    color: #17a2b8;
}

.table__data {}

.table__data--main {
    font-weight: 700;
}

.table__data--no-result {
    text-align: center;
    opacity: 0.8;
}

.table__row {
    cursor: pointer;
}

/* Ensure filter input doesn't take full width on large screens */
@media (min-width: 1024px) {
    :deep(.filter--main) {
        flex: 0 1 auto;
        min-width: 300px;
    }

    :deep(.filter--main input) {
        min-width: 300px;
    }
}

</style>
